import { DIR_LTR, FELOCALE, NAV_TYPE_SIDE, SIDE_NAV_LIGHT } from 'constants/ThemeConstant'

export const APP_NAME =  process.env.REACT_APP_ENV.includes('ghost') ? 'EVC - Ghost OCPP' : 'EVC - Portal'
export const APP_VERSION = process.env.REACT_APP_ENV.includes('ghost') ? 'v1.5.0' : 'v1.3.0'
export const API_BASE_URL = 'http://localhost'
export const APP_PREFIX_PATH = '/portal'
export const AUTH_PREFIX_PATH = '/auth'
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/analytics`
export const UNAUTHENTICATED_ENTRY = '/login'
const lang = localStorage.getItem(FELOCALE)
const theme = localStorage.getItem('theme')
export const THEME_CONFIG = {
    navCollapsed: false,
    sideNavTheme: SIDE_NAV_LIGHT,
    locale: lang,
    navType: NAV_TYPE_SIDE,
    topNavColor: '#3e82f7',
    headerNavColor: '',
    mobileNav: false,
	currentTheme: theme === 'dark' ? 'dark' : 'light',
    direction: DIR_LTR,
    blankLayout: false,
    headerLanguage: 'tr-TR',
}
